var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('sub-visual', {
    attrs: {
      "subTabNone": "",
      "sh": "개인정보처리방침",
      "bg": "/images/sub/visual/sv6.jpg"
    }
  }), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('section', {
    staticClass: "page-section"
  }, [_c('h4', {
    staticClass: "tit tit--sm line-height-1 mb-8 mb-lg-16"
  }, [_vm._v(" 개인정보 수집 및 이용 동의 ")]), _c('v-card', {
    staticStyle: {
      "border-color": "#ececec"
    },
    attrs: {
      "elevation": "0",
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "pa-20"
  }, [_c('ul', {
    staticClass: "dot-texts page-text page-text--sm"
  }, [_c('li', {
    staticClass: "dot-text dot-text--sm"
  }, [_vm._v(" 수집 및 이용목적 : 효성 CMS 출금이체를 통한 요금수납, 소득공제 영수증 발급 ")]), _c('li', {
    staticClass: "dot-text dot-text--sm"
  }, [_vm._v(" 수집항목 : 성명, 생년월일, 연락처, 예금주명, 계좌번호, 예금주 휴대전화번호 ")]), _c('li', {
    staticClass: "dot-text dot-text--sm"
  }, [_vm._v(" 보유 및 이용 기간 : 수집, 이용 동의 일로부터 자동이체 종료일(해지일) 까지 ")]), _c('li', {
    staticClass: "dot-text dot-text--sm"
  }, [_vm._v(" 신청자는 개인정보 수집 및 이용을 거부할 권리가 있으며, 권리 행사 시 출금이체 신청이 거부될 수 있습니다. ")])])])])], 1), _c('section', {
    staticClass: "page-section"
  }, [_c('h4', {
    staticClass: "tit tit--sm line-height-1 mb-8 mb-lg-16"
  }, [_vm._v(" 개인정보 제 3자 제공 동의 ")]), _c('v-card', {
    staticStyle: {
      "border-color": "#ececec"
    },
    attrs: {
      "elevation": "0",
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "pa-20"
  }, [_c('ul', {
    staticClass: "dot-texts page-text page-text--sm"
  }, [_c('li', {
    staticClass: "dot-text dot-text--sm"
  }, [_vm._v(" 개인정보를 제공 받는 자: 효성에프엠에스(주), 금융기관, 통신사, 국세청(홈택스) ")]), _c('li', {
    staticClass: "dot-text dot-text--sm"
  }, [_vm._v(" 개인정보를 제공받는 자의 이용목적 : 자동이체서비스 제공 및 자동이체 동의 사실 통지 ")]), _c('li', {
    staticClass: "dot-text dot-text--sm"
  }, [_vm._v(" 제공하는 개인정보의 항목 : 성명, 생년월일, 연락처, 은행명, 예금주명, 계좌번호, 예금주 휴대전화번호 ")]), _c('li', {
    staticClass: "dot-text dot-text--sm"
  }, [_vm._v(" 개인정보를 제공 받는 자의 개인정보 보유 및 이용 기간 : 동의일로부터 자동이체의 종료일(해지일)까지. 단, 관계 법령에 의거 일정기간 동안 보관 ")]), _c('li', {
    staticClass: "dot-text dot-text--sm"
  }, [_vm._v(" 신청자는 개인정보에 대해 수납업체가 제3자에 제공하는 것을 거부할 수 있습니다. 단, 거부 시 자동이체 신청이 처리되지 않습니다. ")])])])])], 1)])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }